import React from 'react';
import PropTypes from 'prop-types';
// import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import DownArrow from '@material-ui/icons/KeyboardArrowDown';

import { Redirect } from 'react-router-dom';
// import { Transition } from 'react-transition-group';

import NavBar from '../nav/NavBar';
import ThreeOptionsSection from './ThreeOptionsSection';
// import AsSeenOnSection from './AsSeenOnSection';
import WhatIsNiaSection from './WhatIsNiaSection';
// import ResillienceSection from './ResillienceSection';
import NiaDayGuideSection from './NiaDayGuideSection';
import GlobalSection from './GlobalSection';
import NiaTVSection from './NiaTVSection';
// import NiaWearSection from './NiaWearSection';
// import MembershipSection from './MembershipSection';
import MoreThanSection from './MoreThanSection';
import { SaleSection } from './SaleSection';
// import { MemorialDay2024SaleSection as SaleSection } from './SaleSection';
import EmailContactSignup from './EmailContactSignup';
// import FooterSpacer from '../footer/FooterSpacer';

import Footer from '../footer/Footer';

// import swooshOverlay from '../../static/img/swooshOverlayWhite.png';
import heroVideo from '../../static/vid/heroVideoUpdated.webm';
import niaLogo from '../../static/img/logoRedWhite.webp';


const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    paddingBottom: '10%',
  },
  main: {
    minHeight: '100vh',
    width: '100%',
    minWidth: '100%',
    display: 'block', // Fix IE11 issue.
    backgroundColor: 'grey',
    overflowX: 'hidden',
  },
  hero: {
    minHeight: '800px',
    width: '100%',
    position: 'fixed',
    zIndex: 0,
  },
  heroVid: {
    objectFit: 'cover',
    position: 'fixed',
    right: 0,
    bottom: 0,
    minWidth: '100%',
    minHeight: '100%',
    transform: 'translateX(calc((100% - 100vw) / 2))',
  },
  heroOffset: {
    height: 'calc(100vh + 300px)',
    position: 'relative',
    zIndex: -1,
  },
  'div[opacity: 0]': {
    display: 'none',
  },
  heroOpacity: {
    backgroundColor: 'black',
    opacity: '0.5',
    width: '100%',
    height: '100vh',
    position: 'fixed',
  },
  heroContent: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
  },
  quickSearch: {
    width: '100%',
    // height: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      marginTop: theme.spacing(5),
    },
  },
  gridItemLeft: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up(600)]: {
      justifyContent: 'flex-end',
    },
  },
  gridItemRight: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up(600)]: {
      justifyContent: 'flex-start',
    },
  },
  searchForm: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: 'grey',
    // width: '50%',
  },
  searchTextField: {
    backgroundColor: 'white',
    borderRadius: '3px',
    // margin: 0,
  },
  searchText: {
    color: 'white',
    textAlign: 'center',
    marginBottom: theme.spacing(),
  },
  searchButton: {
    margin: theme.spacing(),
  },
  heroHeader: {
    color: 'white',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontSize: '2rem',
    [theme.breakpoints.up(900)]: {
      fontSize: '3rem',
    },
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(3),
  },
  heroSubtext: {
    color: 'white',
    // fontFamily: 'Dancing Script, cursive',
    fontSize: '1.4rem',
    textTransform: 'uppercase',
    letterSpacing: '3px',
    [theme.breakpoints.up(900)]: {
      fontSize: '2.125rem',
    },
  },
  logo: {
    display: 'flex',
    width: '200px',
    margin: theme.spacing(3),
    [theme.breakpoints.up(900)]: {
      width: '300px',
    },
    marginTop: theme.spacing(5),
  },
  downArrowContainer: {
    textAlign: 'center',
  },
  downArrow: {
    color: 'grey',
    width: '64px',
    height: '64px',
    animation: 'bounce 2000ms',
    animationIterationCount: 'infinite',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      marginTop: theme.spacing(10),
    },
  },
  '@keyframes bounce': {
    '0%': {
    },
    '20%': {
    },
    '70%': {
      transform: 'translateY(-10px)',
    },
    '80%': {
      transform: 'translateY(0)',
    },
    '90%': {
      transform: 'translateY(-5px)',
    },
    '100%': {
      transform: 'translateY(0)',
    },
  },
  centeredButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  actionButton: {
    margin: theme.spacing(),
  },
});

// const defaultOverlayStyle = {
//   transition: `opacity ${200}ms ease-in-out`,
//   opacity: 0,
// };

// const transitionOverlayStyles = {
//   entering: { opacity: 0, display: 'block' },
//   entered: { opacity: 0, display: 'none' },
//   exiting: { opacity: 1, display: 'block' },
//   exited: { opacity: 1, display: 'block' },
// };


class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      // overlayScale: 1,
      hideOverlay: false,
      redirect: false,
      // overlayWasHidden: false,
      showHeroLogo: false,
      showHeroSubtext: false,
      // showHeroHeader: false,
      showHeroSearch: false,
    };

    // this.handleScroll = this.handleScroll.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.hideOverlay = this.hideOverlay.bind(this);
    // this.unhideOverlay = this.unhideOverlay.bind(this);
  }

  componentDidMount() {
    // window.addEventListener('scroll', this.handleScroll);

    // this preload didn't help
    // const img = new Image();
    // img.src = niaLogo;

    setTimeout(() => {
      this.setState({
        // showHeroHeader: true,
      });
    }, 0);
    setTimeout(() => {
      this.setState({
        showHeroLogo: true,
      });
    }, 300);
    setTimeout(() => {
      this.setState({
        showHeroSubtext: true,
      });
    }, 600);
    setTimeout(() => {
      this.setState({
        showHeroSearch: true,
      });
    }, 900);
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  // handleScroll() {
  //   const computed = window.pageYOffset;
  //   const scale = 1 + (computed / 50);
  //   const { overlayWasHidden } = this.state;
  //   const shouldHideOverlay = computed > 120;

  //   this.setState({
  //     overlayScale: scale > 1 ? scale : 1,
  //   });
  //   if (shouldHideOverlay && !overlayWasHidden) {
  //     this.hideOverlay();
  //   }
  //   if (!shouldHideOverlay && overlayWasHidden) {
  //     this.unhideOverlay();
  //   }
  // }

  // hideOverlay() {
  //   this.setState({
  //     overlayWasHidden: true,
  //     hideOverlay: true,
  //   });
  // }

  // unhideOverlay() {
  //   this.setState({
  //     overlayWasHidden: false,
  //     hideOverlay: false,
  //     showHeroHeader: false,
  //     showHeroLogo: false,
  //     showHeroSubtext: false,
  //     showHeroSearch: false,
  //   });
  // }

  handleSearchChange(e) {
    this.setState({
      searchText: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      redirect: true,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      // overlayScale,
      hideOverlay,
      searchText,
      redirect,
      // showHeroHeader,
      showHeroLogo,
      showHeroSubtext,
      showHeroSearch,
    } = this.state;

    if (redirect) {
      return (
        <Redirect to={{ pathname: '/finder/class/' + encodeURI(searchText) }} />
      );
    }
    return (
      <div className={classes.page}>

        <NavBar elevation={hideOverlay ? 3 : 0} />

        <main className={classes.main}>
          <div className={classes.hero}>
            <video className={classes.heroVid} autoPlay muted loop id="myVideo">
              <source src={heroVideo} type="video/webm" />
            </video>
            <div className={classes.heroOpacity} />
            {/* OVERLAY */}
            {/* <Transition
              in={hideOverlay}
              timeout={200}
            >
              {val => (
                <div
                  className={classes.overlay}
                  style={{
                    transform: 'scale(' + overlayScale + ', ' + overlayScale + ')',
                    ...defaultOverlayStyle,
                    ...transitionOverlayStyles[val],
                  }}

                />
              )}
            </Transition> */}
            {/* HERO CONTENT */}
            <div className={classes.heroContent}>
              <div className={classes.appBarSpacer} />
              {/* <Fade
                in={showHeroHeader}
                timeout={500}
              >
                <Typography className={classes.heroHeader} variant="h3">Fitness. Wellness. Lifestyle.</Typography>
              </Fade> */}
              <Fade
                in={showHeroLogo}
                timeout={500}
              >
                <img src={niaLogo} alt="Nia" className={classes.logo} />
              </Fade>
              <Fade
                in={showHeroSubtext}
                timeout={500}
              >
                <Typography className={classes.heroSubtext} variant="h1">love how you feel</Typography>
              </Fade>
              {/* SEARCH */}
              <Fade
                in={showHeroSearch}
                timeout={500}
              >
                <div className={classes.quickSearch}>
                  <form className={classes.searchForm} onSubmit={this.handleSubmit}>
                    <Grid container justifyContent="center">
{/*                      <Grid item xs={12}>
                        <Typography className={classes.searchText} variant="h6">Start Your 14-Day Free Trial of Nia® On Demand</Typography>
                      </Grid>*/}
                      {/* <Grid item xs={12} sm={7} className={classes.gridItemLeft}>
                        <TextField
                          id="outlined-search"
                          label="Search City, State, Zip"
                          className={classes.searchTextField}
                          margin="normal"
                          variant="filled"
                          onChange={this.handleSearchChange}
                          value={searchText}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5} className={classes.gridItemRight}>
                        <Button
                          className={classes.searchButton}
                          variant="contained"
                          color="primary"
                          // size="large"
                          type="submit"
                        >
                          Step In
                        </Button>
                      </Grid> */}
                      <Grid item xs={12}>
                        <div className={classes.centeredButton}>
                          <Button variant="contained" color="primary" size="large" className={classes.actionButton} href="/finder/class">Find a Class</Button>
                          <Button variant="contained" color="primary" size="large" className={classes.actionButton} target="_blank" rel="noopener noreferrer" href="https://niaondemand.com">Nia On Demand</Button>
                          <Button variant="contained" color="primary" size="large" className={classes.actionButton} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/groups/nialife">Join Our Community</Button>
                        </div>
                      </Grid>
                    </Grid>
                  </form>
                </div>
              </Fade>
              <div className={classes.downArrowContainer}>
                <DownArrow className={classes.downArrow} />
              </div>
            </div>
          </div>
          <div className={classes.heroOffset} />

          {/* <SaleSection /> */}

          {/* <ResillienceSection /> */}

          <NiaDayGuideSection />

          <ThreeOptionsSection />

          {/* <AsSeenOnSection /> */}

          <WhatIsNiaSection />

          <GlobalSection />

          <NiaTVSection />

          {/* <MembershipSection /> */}

          {/* <NiaWearSection /> */}

          <MoreThanSection />

          <EmailContactSignup />

          {/* background is clear, this won't work, instead put spacer in bottom most section */}
          {/* <FooterSpacer /> */}
        </main>
        <Footer />
      </div>
    );
  }
}

Homepage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Homepage);
